import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { RestoreAccount, RestoreAccountParams } from './model';
import { RestoreAccountView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function RestoreAccountRoute (
    model : (params : RestoreAccountParams) => RestoreAccount,
    appWrapper : AppWrapper,
    request : Location
) {
    return {
        view :
            <AppWrapperView model={appWrapper}>
                <RestoreAccountView model={model(inboundParams(request))} />
            </AppWrapperView>
    };
}

function inboundParams(request : Location) : RestoreAccountParams {
    return {
        invitationId: +(request.params['invitationId'] || 0),
        token: request.params['token'] || ''
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/restoreaccount/route.tsx